var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommercialScreenIcon = function SvgCommercialScreenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.875 49.013H6.125c-2.35 0-4.25-1.9-4.25-4.25V6.125c0-2.35 1.9-4.25 4.25-4.25h51.75c2.35 0 4.25 1.9 4.25 4.25v38.638c0 2.337-1.9 4.25-4.25 4.25Z",
    fill: "#8CB3DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.875 1.875H31.987v47.138h25.888c2.35 0 4.25-1.9 4.25-4.25V6.125c0-2.35-1.9-4.25-4.25-4.25Z",
    fill: "#E87F56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 25.438V44.75c0 2.35 1.9 4.25 4.25 4.25h51.75c2.35 0 4.25-1.9 4.25-4.25V25.437H1.875Z",
    fill: "#F7F7F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.987 25.438V49h25.888c2.35 0 4.25-1.9 4.25-4.25V25.437H31.987Z",
    fill: "#053249"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m21.625 61.987 2.038-12.974h16.612L42.1 61.987H21.625Z",
    fill: "#014A99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.987 61.987h10.1l-1.825-12.974h-8.275v12.974Z",
    fill: "#053249"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.825 63.85h-29.65a1.872 1.872 0 0 1-1.875-1.875c0-1.037.837-1.875 1.875-1.875h29.65c1.037 0 1.875.838 1.875 1.875a1.872 1.872 0 0 1-1.875 1.875Z",
    fill: "#1C7CE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.825 60.1H31.987v3.75h14.838a1.872 1.872 0 0 0 1.875-1.875 1.872 1.872 0 0 0-1.875-1.875Z",
    fill: "#014A99"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.625 40.063a4.325 4.325 0 1 0 0-8.65 4.325 4.325 0 0 0 0 8.65Z",
    fill: "#FFA64D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.625 31.413v8.65a4.326 4.326 0 0 0 4.325-4.325 4.326 4.326 0 0 0-4.325-4.325Z",
    fill: "#F93"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.425 40.737H43.75c-2.4.026-4.337 1.963-4.337 4.363v.975c0 .638.512 1.15 1.15 1.15H52.65c.638 0 1.15-.512 1.15-1.15V45.1a4.37 4.37 0 0 0-4.375-4.363Z",
    fill: "#AEDAFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.425 40.737h-2.8v6.5h6.038c.637 0 1.15-.512 1.15-1.15v-.975a4.39 4.39 0 0 0-4.388-4.375Z",
    fill: "#8CB3DC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.45 40.063a4.325 4.325 0 1 0 0-8.65 4.325 4.325 0 0 0 0 8.65Z",
    fill: "#FC9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.45 31.413v8.65a4.326 4.326 0 0 0 4.325-4.325 4.318 4.318 0 0 0-4.325-4.325Z",
    fill: "#FFB366"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.262 40.737h-5.675a4.38 4.38 0 0 0-4.337 4.375v.975c0 .638.512 1.15 1.15 1.15h12.088c.637 0 1.15-.512 1.15-1.15v-.975a4.38 4.38 0 0 0-4.376-4.375Z",
    fill: "#99EDBA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.263 40.737H17.45v6.5h6.038c.637 0 1.15-.512 1.15-1.15v-.975a4.38 4.38 0 0 0-4.375-4.375Z",
    fill: "#57C975"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.625 18.275a4.325 4.325 0 1 0 0-8.65 4.325 4.325 0 0 0 0 8.65Z",
    fill: "#FFA64D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.625 9.625v8.65a4.326 4.326 0 0 0 4.325-4.325 4.326 4.326 0 0 0-4.325-4.325Z",
    fill: "#F93"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.425 18.95H43.75c-2.4.025-4.337 1.963-4.337 4.363v.975c0 .637.512 1.15 1.15 1.15H52.65c.638 0 1.15-.513 1.15-1.15v-.976a4.361 4.361 0 0 0-4.375-4.362Z",
    fill: "#FFD553"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.425 18.95h-2.8v6.5h6.038c.637 0 1.15-.512 1.15-1.15v-.975a4.382 4.382 0 0 0-4.388-4.375Z",
    fill: "#EFB920"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.45 18.275a4.325 4.325 0 1 0 0-8.65 4.325 4.325 0 0 0 0 8.65Z",
    fill: "#FC9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.45 9.625v8.65a4.326 4.326 0 0 0 4.325-4.325 4.318 4.318 0 0 0-4.325-4.325Z",
    fill: "#FFB366"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.262 18.95h-5.675a4.361 4.361 0 0 0-4.337 4.363v.975c0 .637.512 1.15 1.15 1.15h12.088c.637 0 1.15-.513 1.15-1.15v-.976a4.37 4.37 0 0 0-4.376-4.362Z",
    fill: "#1C7CE5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.263 18.95H17.45v6.5h6.038c.637 0 1.15-.512 1.15-1.15v-.975a4.372 4.372 0 0 0-4.375-4.375Z",
    fill: "#014A99"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.375 50.887H5.625A5.625 5.625 0 0 1 0 45.262V5.637A5.625 5.625 0 0 1 5.625.012h52.75A5.625 5.625 0 0 1 64 5.637v39.625c0 3.1-2.525 5.625-5.625 5.625ZM5.625 3.75a1.883 1.883 0 0 0-1.888 1.875V45.25c0 1.037.838 1.887 1.888 1.887h52.75a1.886 1.886 0 0 0 1.888-1.887V5.625a1.886 1.886 0 0 0-1.888-1.888l-52.75.013Z",
    fill: "#1C7CE5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.837 0h-26.85v3.75h26.85c.775 0 1.413.625 1.413 1.412v39.976c0 1.1-.9 2-2 2H31.987v3.75h26.85A5.164 5.164 0 0 0 64 45.725V5.15C64 2.312 61.687 0 58.837 0Z",
    fill: "#014A99"
  })));
};
export default SvgCommercialScreenIcon;